import { mixed, object, string } from "yup";

import type { I18nT } from "@lib/dashboardI18n";
import sharedConstants from "@lib/shared_constants";

import { getRcsActionsSchema, getRcsBaseSchema, getRcsMediaFieldsSchema } from ".";

export const getRcsMediaSchema = (t: I18nT<"rcs-composer">, isTwilioProvider?: boolean) =>
  getRcsBaseSchema(t)
    .concat(getRcsActionsSchema(t))
    .concat(
      object({
        type: mixed<"media">().oneOf(["media"]).required(),
        body: string()
          .maxLengthIgnoringLiquid(
            isTwilioProvider
              ? sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_TEXT_TWILIO
              : sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_TEXT,
            t("rcs-text-body-length-error", "Message exceeds the character limit")
          )
          .optional(),
      }).concat(getRcsMediaFieldsSchema(t))
    )
    .noUnknown();
